var map = {
	"./filter-boxes-icon-non-active.svg": 61358,
	"./filter-campaigns-icon-non-active.svg": 71268,
	"./filter-diabetes-icon-non-active.svg": 86790,
	"./filter-emergency-icon-non-active.svg": 81042,
	"./filter-hospitals-icon-non-active.svg": 52252,
	"./filter-lockit-icon-non-active.svg": 85819,
	"./filter-patients-icon-non-active.svg": 55883
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13741;